import { forgotPassword } from '@authentication/services/authServices';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import ForgotPasswordRequestDto from '@authentication/models/forgot-password.request.dto';

const useForgotPasswordMutation = (): UseMutationResult<
  AxiosResponse<null>,
  unknown,
  ForgotPasswordRequestDto,
  unknown
> => {
  const forgotPasswordMutation = useMutation({
    mutationFn: forgotPassword,
  });

  return forgotPasswordMutation;
};
export default useForgotPasswordMutation;
